<template>
  <div>
    <icon-button
      type="button"
      icon="calendar_today"
      :icons-outlined="true"
      :reduce="buttonReduce"
      :classes="'btn -material -add -ico-txt'"
      label="Add To Calendar"
      @click-action="openCalendarModal"
    />

    <!-- can pass in any custom HTML / dom -->
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapState, mapActions } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'
import { useModalsStore } from '@/stores/modals'
import IconButton from '@/components/buttons/icon-button.vue'

/**
 * Button to schedule program
 */
export default defineComponent({
  components: { IconButton },

  props: {
    // custom classes for calendar button
    classes: {
      type: String,
      default: '',
    },

    // plan info
    entityId: {
      required: true,
      type: Number,
    },

    // entityType = plan, no need to pass in

    // passed up to modal calendar but not currently used by it
    // should be lowercase plan.brand.name
    entityCategory: {
      type: String,
      default: '',
    },

    // passed up to modal calendar but not currently used by it
    entityTitle: {
      default: '',
      type: String,
    },

    buttonReduce: {
      default: true,
      type: Boolean,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapState(useUserAuthStore, ['user']),
  },

  methods: {
    ...mapActions(useModalsStore, ['showLoginModal', 'openSimpleModal']),

    openCalendarModal() {
      if (!this.user.isLoggedIn) {
        this.showLoginModal()
        return
      }

      this.openSimpleModal({
        type: 'CALENDAR_ADD',
        props: {
          entityId: this.entityId,
          entityType: 'plan',
          entityTitle: this.entityTitle,
          entityCategory: this.entityCategory,
        },
      })
    },
  },
})
</script>
